import { Injectable } from '@angular/core';
import { ConfigBaseFilter, ListLayout, ListLayoutMultipleComponent, SimpleConfigBaseFilter } from 'gung-list';
import { ActivityInternal, ActivityInternalListConfigService, ActivityInternalStatusFilter, ActivityInternalTypeFilter, MetadataService } from 'gung-standard';
import { CultActivityInternalTableComponent } from '../components/cult-activity-internal-table/cult-activity-internal-table.component';
import { ActivityInternalCustomerResponsibleFilter, ActivityInternalDateFilter } from './cult-activity-internal-list-config.service';
import { Observable, map } from 'rxjs';
import { gungComparatorHelper } from 'gung-common';

@Injectable({
  providedIn: 'root'
})
export class CultActivityInternalCustomerListConfigService extends ActivityInternalListConfigService {
  getFilters(): ConfigBaseFilter<ActivityInternal>[] {
    return [
      new ActivityInternalStatusFilter(this.metadataService),
      new ActivityInternalTypeFilter(this.metadataService),
      new ActivityInternalCustomerResponsibleFilter(this.metadataService),
      new ActivityInternalDateFilter()
    ];
  }

  getItems(): Observable<ActivityInternal[]> {
    return super.getItems().pipe(
      map(result =>
        result.sort((a, b) => gungComparatorHelper(new Date(a.activityDate), new Date(b.activityDate), 1))
      )
    )
  }

  getLayouts(): ListLayout<ActivityInternal>[] {
    return [
      {
        getIconClass: () => '',
        getListItemComponent: () => CultActivityInternalTableComponent,
        getListLayoutComponent: () => ListLayoutMultipleComponent,
        getName: () => 'Order list'
      }
    ];
  }
}
